import React from 'react';

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Typography,
  Button,
} from '@mui/material';
import { useRecoilValue } from 'recoil';
import { dashboardState } from '../../state/RecoilState';
import { DebtorListItem } from '../../@types/api';
import dayjs from 'dayjs';
import { colDateFormat } from '../../Constants';
import { useNavigate } from 'react-router-dom';

const DebtorsList = () => {
  const navigate = useNavigate();
  const dashboard = useRecoilValue(dashboardState);
  const data = dashboard?.debtors;
  if (!data || data.length === 0) return null;
  return (
    <Box sx={{ py: 1 }}>
      <Typography variant='h5'>Debtors</Typography>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell>BookingID</TableCell>
            <TableCell>ClientID</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Telephone</TableCell>
            <TableCell align='right'>Deposit</TableCell>
            <TableCell align='right'>Paid</TableCell>
            <TableCell align='right'>EventDate</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row: DebtorListItem) => (
            <TableRow key={row.bookingId}>
              <TableCell>
                <Button
                  size='small'
                  color='secondary'
                  variant='contained'
                  onClick={() => navigate(`/booking/edit/${row.bookingId}`)}
                >
                  {row.bookingId}
                </Button>
              </TableCell>
              <TableCell>{row.clientId}</TableCell>
              <TableCell>{row.emailAddress}</TableCell>
              <TableCell>
                {row.firstName} {row.surname}
              </TableCell>
              <TableCell align='right'>
                {row.mobile ?? row.telephoneNumber}
              </TableCell>
              <TableCell align='right'>{row.deposit}</TableCell>
              <TableCell align='right'>{row.amountPaid}</TableCell>
              <TableCell align='right'>
                {dayjs(row.eventDate).format(colDateFormat)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default DebtorsList;
